<template>
  <div class="container">
    <div class="modal">
     <slot></slot>
    </div>
  </div>
</template>
<script>
  export default {
    
  }
</script>
<style scoped>
.container{
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000!important;
  background: rgba(146, 153, 187, 0.356);
  backdrop-filter: blur(2px);
  display: flex;
  justify-content: center;
  align-content: center;
}

@keyframes growIn {
  from {
    opacity: 0;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    transform: scale(1); 
  }
}

.modal{
  width: fit-content;
  min-width: 10rem;
  border-radius: 1rem;
  background: #FFFFFF;
  margin: 0 auto;
  padding: 1rem;
  animation: growIn 0.15s ease-out forwards; 
}
</style>